<template>
	<div class="flex flex-grow">
		<div class="md:gap-1 flex-grow items-baseline">
			<div class="flex space-x-4" v-if="!isLoading">
				<div class="text-left flex w-full">
					<div class="space-x-4 flex flex-grow flex-row">
						<div class="flex w-full">
							<div class="w-1/2 pr-2 border-gray-400 border-r-2">
								<div class="flex mb-6">
									<div class="flex w-1/2 text-left">
										{{ $t('damage_amount_net') }}
									</div>
									<div class="flex w-1/2 text-left pl-2">
										{{ $t('fee_net') }}
									</div>
								</div>
								<div v-for="(element, index) in firstFeeList" :key="index" class="grid grid-cols-2 gap-4">
									<BaseInputNumber
										:ref="`BaseInput.amount_of_damage_${index}`"
										:placeholder="$t('damage_amount')"
										v-model="firstFeeList[index].amount_of_damage"
										:precision="2"
										:tab-index="index * 2 + 1"
										:disabled="false"
										:required="true"
									/>
									<BaseInputNumber
										:ref="`BaseInput.companyFees_${index}`"
										:placeholder="$t('fee')"
										v-model="firstFeeList[index].fee"
										:precision="2"
										:tab-index="index * 2 + 2"
										:required="true"
									/>
								</div>
								<div class="flex tr grid gap-4 flex-grow md:grid-cols-2">
									<BaseInputNumber
										:ref="`BaseInput.amount_of_damage_max_fee`"
										:placeholder="$t('per_2.5_euro')"
										:precision="2"
										:tab-index="1000000"
										:disabled="true"
									/>
									<BaseInputNumber
										:ref="`BaseInput.companyFees_maxFee`"
										:placeholder="$t('fee')"
										v-model="damageAssessorCompany.fee_max_damage_amount"
										:precision="2"
										:tab-index="1000000"
										:required="true"
									/>
								</div>
							</div>
							<div class="w-1/2 pl-2">
								<div class="flex mb-6">
									<div class="flex w-1/2 text-left">
										{{ $t('damage_amount_net') }}
									</div>
									<div class="flex w-1/2 text-left pl-2">
										{{ $t('fee_net') }}
									</div>
								</div>
								<div v-for="(element, index) in secondFeeList" :key="index" class="grid grid-cols-2 gap-4">
									<BaseInputNumber
										:ref="`BaseInput.amount_of_damage_${index}`"
										:placeholder="$t('damage_amount')"
										v-model="secondFeeList[index].amount_of_damage"
										:precision="2"
										:tab-index="firstFeeList.length * 2 + index * 2 + 1"
										:disabled="false"
										:required="true"
									/>
									<BaseInputNumber
										:ref="`BaseInput.companyFees_${index}`"
										:placeholder="$t('fee')"
										v-model="secondFeeList[index].fee"
										:precision="2"
										:tab-index="firstFeeList.length * 2 + index * 2 + 2"
										:required="true"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<LoadingSpinner v-else />
		</div>
	</div>
</template>

<script>
import BaseInputNumber from '@/components/forms/inputs/BaseInputNumber.vue';
import { DamageassessorpricingApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import CompanyRepository from '@/api/repositories/CompanyRepository';
import Validate from '@/mixins/Validate';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';

export default {
	components: { LoadingSpinner, BaseInputNumber },
	name: 'OnboardingCompanyFeeAgreement',
	mixins: [Validate],
	data() {
		return {
			isLoading: false,
			companyData: [],
			damageAssessorCompany: {},
			firstFeeList: [],
			secondFeeList: [],
		};
	},
	mounted() {
		this.isLoading = true;
		this.getDamageAssessorPricing();
		this.getExtraCosts();
	},
	methods: {
		getDamageAssessorPricing() {
			this.isLoading = true;
			return DamageassessorpricingApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.damageassessorpricingGet(undefined, 100)
				.then(response => {
					this.companyData = response.data.companyData;
					const list = this.companyData.fees;
					const half = Math.ceil(list.length / 2);
					this.firstFeeList = list.slice(0, half);
					this.secondFeeList = list.slice(half);
				})
				.catch(error => {
					this.isLoading = false;
				});
		},
		getExtraCosts() {
			new CompanyRepository()
				.getDamageAssessorCompanyExtraCosts()
				.then(response => {
					this.damageAssessorCompany = response.data;
					this.isLoading = false;
				})
				.catch(e => {
					console.log(e);
					this.isLoading = false;
				});
		},
		getData() {
			return { fees: [...this.firstFeeList, ...this.secondFeeList], extraCosts: this.damageAssessorCompany };
		},
	},
};
</script>
